import { render, staticRenderFns } from "./BoardCardsSales.vue?vue&type=template&id=558c08c9&"
import script from "./BoardCardsSales.vue?vue&type=script&lang=js&"
export * from "./BoardCardsSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports